// Top-level React error boundary.
//
// Catches uncaught render errors anywhere in the tree, shows a friendly fallback,
// and logs to console (later: pipe to Sentry / a remote logger).

import React from 'react'
import PropTypes from 'prop-types'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    // Phase 2: console only. Phase 7 will replace with a real error reporter.
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info?.componentStack)
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            background: '#f6f7f9',
            fontFamily: 'system-ui, -apple-system, sans-serif',
          }}
        >
          <div
            style={{
              maxWidth: 480,
              background: '#fff',
              padding: '32px',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
              textAlign: 'center',
            }}
          >
            <h3 style={{ margin: '0 0 12px', color: '#222' }}>Something went wrong</h3>
            <p style={{ margin: '0 0 20px', color: '#666', fontSize: 14 }}>
              The page hit an unexpected error. Please reload — if the problem persists,
              contact support.
            </p>
            <button
              type="button"
              onClick={this.handleReload}
              style={{
                background: '#1f6feb',
                color: '#fff',
                border: 'none',
                padding: '10px 22px',
                borderRadius: 6,
                cursor: 'pointer',
                fontSize: 14,
              }}
            >
              Reload page
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
}

export default ErrorBoundary
